import { render, staticRenderFns } from "./Clinical.vue?vue&type=template&id=179540f3&scoped=true&"
import script from "./Clinical.vue?vue&type=script&lang=js&"
export * from "./Clinical.vue?vue&type=script&lang=js&"
import style0 from "./Clinical.vue?vue&type=style&index=0&id=179540f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179540f3",
  null
  
)

export default component.exports